<template>
  <ComDialog :isShow="dialogVisible" :width="400" title="切换角色" alignCenter @close="handleClose">
    <div>
      <el-radio-group v-model="currentRoleObj">
        <el-radio v-for="(role,index) in roleList" :key="index" :label="role.id">{{ role.roleName }}</el-radio>
      </el-radio-group>
    </div>
    <div class="dialog-footer">
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </ComDialog>
</template>

<script setup>
import { ref, defineExpose, computed } from "vue";
import ComDialog from "@/components/comDialog/index.vue";
const dialogVisible = ref(false);
const currentRoleObj = ref("");
const props = defineProps(["roleList"]);
const emit = defineEmits(["update-role"]);
const roleList = computed(() => {
  return props.roleList || [];
});
const open = currentRole => {
  currentRoleObj.value = currentRole.id;
  dialogVisible.value = true;
};

const handleClose = () => {
  dialogVisible.value = false;
};

const submit = () => {
  const data = roleList.value.find(ele => ele.id == currentRoleObj.value);
  emit("update-role", data);
  dialogVisible.value = false;
};
defineExpose({ open });
</script>

<style>
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
</style>